import Image from "next/legacy/image";
import Otp from "./components/Otp/Otp";
import { useEffect, useMemo, useRef, useState } from "react";
import Phone from "./components/Phone/Phone";
import CloseIcon from "@svg/closeIcon";
import { useUI } from "@context/ui-managed-context";
import { useRouter } from "next/router";
import { useAppContext } from "@context/app";
import useEvents from "@hooks/useEvents";
import { COOKIE_IGNORE_PHONE_VERIFICATION, COOKIE_IGNORE_PHONE_VERIFICATION_CHECKOUT } from "@utils/constants";
import { OtpRef } from "./components/Otp";
import { useTranslations } from "next-intl";


interface VerifyPhoneNumberProps {


}






const VerifyPhoneNumber: React.FC<VerifyPhoneNumberProps> = () => {
  const { setModalView, openModal, modalView } = useUI()
  const [step, setStep] = useState<"OTP" | "PHONE_NUMBER">("PHONE_NUMBER")
  const [countryCode, setCountryCode] = useState("")
  const [phoneNumber, setPhoneNumber] = useState("")
  const [wait, setWait] = useState(60)
  const { locale, pathname } = useRouter()
  const { syncData } = useAppContext()
  const { OTPFormClosed, verifyPhoneFormClosed } = useEvents()
  const otpRef = useRef<OtpRef>(null);
  const t = useTranslations()






  const suggestedPhone: string | undefined = modalView.args[0]
  const defaultStep: "OTP" | "PHONE_NUMBER" | undefined = modalView.args[1]
  const timer: number | undefined = modalView.args[2]
  const onComplete: undefined | ((finishedAndVerified: boolean) => void) = modalView.args[3]
  useEffect(() => {
    if (defaultStep) {
      setStep(defaultStep)
      if (timer || timer === 0) {
        setWait(timer)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultStep])
  useEffect(() => {
    if (syncData?.countries.length && suggestedPhone) {
      const country = syncData.countries.find((c) => suggestedPhone.startsWith(c.dialcode))
      if (country) {
        setCountryCode(country.dialcode)
        setPhoneNumber(suggestedPhone.split(country.dialcode)[1])
      }
    }
  }, [syncData, suggestedPhone])


  const handelClose = () => {
    if (step === "OTP") {
      OTPFormClosed()
    } else {
      verifyPhoneFormClosed(suggestedPhone ? true : false)
    }
    setModalView("VERIFY_PHONE_NUMBER_EXIT", false, suggestedPhone || (countryCode && phoneNumber) ? `${countryCode}${phoneNumber}` : undefined, step, handleGetSeconds(),onComplete);
    openModal();
  }


  const handleGetSeconds = () => {
    if (otpRef.current) {
      return otpRef.current.getSeconds()
    }
  };


  const options = useMemo(() => {
    switch (pathname) {
      case "/settings":
        return {
          isOptional: true,
          interval: 0,
          cookie: ""
        }
      case "/checkout":
        return {
          isOptional: syncData?.phone_verification_checkout.mode === "optional",
          interval: syncData?.phone_verification_checkout.interval,
          cookie: COOKIE_IGNORE_PHONE_VERIFICATION_CHECKOUT
        }
      case "/wallet":
        return {
          isOptional: true,
          interval: 0,
          cookie: ""
        }
      default:
        return {
          isOptional: syncData?.phone_verification.mode === "optional",
          interval: syncData?.phone_verification.interval,
          cookie: COOKIE_IGNORE_PHONE_VERIFICATION
        }
    }
  }, [pathname, syncData, defaultStep]);


  const { isOptional } = options
  return (
    <div className="md:w-[480px] sm:w-screen xs:w-screen w-screen max-w-[480px] h-max bg-white" dir={locale?.includes("ar-") ? "rtl" : "ltr"}>
      <div className="w-full !max-h-[728px] h-screen bg-verify-gradient rounded-3xl p-6 flex flex-col gap-3 items-center md:rounded-3xl rounded-b-none overflow-auto no-scrollbar">
        {step === "PHONE_NUMBER" ? <div className="w-full flex justify-end">
          {isOptional ? <button className=" outline-none" onClick={() => handelClose()} >
            <CloseIcon />
          </button> : null}
        </div> : null}
        {step === "OTP" ? <div className="w-full">
          <div className="w-full flex justify-between items-center">
            <button className=" outline-none w-10 h-10 rounded-full bg-white flex items-center justify-center" onClick={() => handelClose()} >
              <CloseIcon stroke="#333333" />
            </button>
            <button className=" outline-none w-max h-max py-2 px-5 rounded-full bg-white flex items-center justify-center text-mui-text-primary font-bold text-sm" onClick={() => handelClose()} >
              {t("client_buttons_skip")}
            </button>
          </div>
        </div> : null}


        <div className="flex-1 flex flex-col gap-3 items-center justify-center w-full">
          <div className=" w-full max-w-[386px] relative">
            <Image src="/imgs/verification.png" width={386} height={280} quality={75} objectFit="contain" alt="success" />
          </div>
          {step === "PHONE_NUMBER" ? (
            <Phone phoneNumber={phoneNumber} countryCode={countryCode} onChangeStep={(step, phone, code, wait) => {
              setWait(wait);
              setPhoneNumber(phone);
              setCountryCode(code);
              setStep(step);
            }} />
          ) : null}
          {step === "OTP" ? (
            <Otp
              ref={otpRef}
              phoneNumber={phoneNumber}
              countryCode={countryCode}
              onChangeStep={setStep}
              timer={wait}
            />
          ) : null}
        </div>




      </div>
    </div >
  );
}


export default VerifyPhoneNumber;